import { StyleSheet } from 'react-native';

import themeStyle from '../../../../Theme/styles';

export default StyleSheet.create({
  listItemWrapper: {
    ...themeStyle.flex1,
    ...themeStyle.pageHorizontalSpacingSmall,
    ...themeStyle.pageVerticalSpacingSmall,
    justifyContent: 'space-between',
    borderWidth: 1,
    borderRadius: 7,
  },
  btn: {
    paddingVertical: 3,
    minHeight: 0,
  },
});
